import { ChangeDetectionStrategy, Component, OnInit, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { AccountsContextService } from 'src/app/accounts/account-context.service';
import { AdvertiserPaymentsAclService } from 'src/app/advertiser/payments/advertiser-payments-acl.service';
import { AdvertiserDataFormAclService } from 'src/app/advertiser/settings/data-form/advertiser-data-form-acl.service';
import { ReportsAclService } from 'src/app/common-logic/reports-common/reports-acl.service';
import { FeedAclService } from 'src/app/publisher/feed/feed-acl.service';
import { PublisherPaymentsAclService } from 'src/app/publisher/payments/publisher-payments-acl.service';
import { PublisherAclService } from 'src/app/publisher/publisher-acl.service';
import { PublisherDataFormAclService } from 'src/app/publisher/settings/data-form/publisher-data-form-acl.service';
import { FeatureFlagsService } from 'src/app/feature-flags/feature-flags.service';
import { ModerationAclService } from 'src/app/acl/shared/moderation-acl.service';
import { Account } from 'src/app/shared/account/account.types';
import { ICON_ADVERTISERS_LIST, ICON_PRODUCT, ICON_QUESTION_MARK } from 'src/app/shared/named-icons.config';

@Component({
  selector: 'app-aside-menu',
  templateUrl: './aside-menu.component.html',
  styleUrls: ['./aside-menu.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AsideMenuComponent implements OnInit {
  public readonly ICON_ADVERTISERS_LIST = ICON_ADVERTISERS_LIST;
  public readonly ICON_PRODUCT = ICON_PRODUCT;
  public readonly ICON_QUESTION_MARK = ICON_QUESTION_MARK;

  public publisherContextId$: Observable<string | undefined>;
  public advertiserContextId$: Observable<string | undefined>;

  public readonly reportsAclService: ReportsAclService;
  public readonly publisherAclService: PublisherAclService;
  public readonly publisherPaymentsAclService: PublisherPaymentsAclService;
  public readonly advertiserPaymentsAclService: AdvertiserPaymentsAclService;
  public readonly feedAclService: FeedAclService;
  public readonly advDataFormAclService: AdvertiserDataFormAclService;
  public readonly pubDataFormAclService: PublisherDataFormAclService;
  public readonly moderationAclService: ModerationAclService;
  public readonly featureFlags: FeatureFlagsService;
  private readonly contextService: AccountsContextService;

  constructor() {
    this.reportsAclService = inject(ReportsAclService);
    this.publisherAclService = inject(PublisherAclService);
    this.publisherPaymentsAclService = inject(PublisherPaymentsAclService);
    this.advertiserPaymentsAclService = inject(AdvertiserPaymentsAclService);
    this.feedAclService = inject(FeedAclService);
    this.advDataFormAclService = inject(AdvertiserDataFormAclService);
    this.pubDataFormAclService = inject(PublisherDataFormAclService);
    this.moderationAclService = inject(ModerationAclService);
    this.featureFlags = inject(FeatureFlagsService);
    this.contextService = inject(AccountsContextService);
  }

  public get isWhiteLabelShop(): boolean {
    return !!this.contextService.accountSnapshot?.whiteLabel
      && (this.contextService.accountSnapshot?.accountType === Account.Type.PUBLISHER);
  }

  public ngOnInit(): void {
    this.publisherContextId$ = this.contextService.account$
      .pipe(
        map(val => Account.isPublisher(val.accountType) && !!val.id ? val.id : undefined)
      );

    this.advertiserContextId$ = this.contextService.account$
      .pipe(
        map(val => Account.isAdvertiser(val.accountType) && !!val.id ? val.id : undefined)
      );
  }
}
